import { render, staticRenderFns } from "./RecordChooseList.vue?vue&type=template&id=129895be&"
import script from "./RecordChooseList.vue?vue&type=script&lang=js&"
export * from "./RecordChooseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports